import React from 'react';
import MathCCA2024 from 'views/MathCCA2024';
const MathClubPage = () => {
  return <MathCCA2024/>;
};

export default MathClubPage;

